import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Alert, Button, Col, Row, ButtonGroup} from "reactstrap";
import {connect} from "react-redux";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import classnames from "classnames";

import api from "api";
import {isMobile} from "react-device-detect";


class Rate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rate: 0,
      rateHover: 0,
      saving: false,
      rated: !!props.surveyResponse.rate
    };

    this.onClickSave = this.onClickSave.bind(this);
  }

  onClickRate(rate){
    this.setState({
      rate
    })
  }

  onClickSave(){
    const {surveyResponse} = this.props;
    this.setState({
      saving: true
    });

    const data = {
      rate: this.state.rate
    };

    api.surveyResponse.postRate(surveyResponse, data).then(data => {
      this.setState({
        saving: false,
        rated: true
      });
    })
  }

  render() {
    const {rate, rateHover, rated, saving} = this.state;

    const rateDisplay = rateHover || rate;

    if(rated){
      return <Alert color="success" className="text-center">Dziękujemy za ocenę ankiet</Alert>
    }

    const rateTexts = {
      1: {
        text: 'Fatalna',
        color: '#a94442'
      },
      2: {
        text: 'Bardzo słaba',
        color: '#a94442'
      },
      3: {
        text: 'Słaba',
        color: '#8a6d3b'
      },
      4: {
        text: 'Ujdzie',
        color: '#8a6d3b'
      },
      5: {
        text: 'Średnia',
        color: '#31708f'
      },
      6: {
        text: 'Niezła',
        color: '#31708f'
      },
      7: {
        text: 'Dobra',
        color: '#31708f'
      },
      8: {
        text: 'Bardzo dobra',
        color: '#337ab7'
      },
      9: {
        text: 'Rewelacyjna',
        color: '#337ab7'
      },
      10: {
        text: 'Wybitna',
        color: '#3c763d'
      },
    };

    let rateButtons = [];
    for(let i=1; i <= 10; i++){
      rateButtons.push(<div
        style={{cursor: "pointer"}}
        onClick={() => this.onClickRate(i)} key={i} value={i}
        onMouseOver={() => {
          this.setState({
            rateHover: i
          });
        }}
        onMouseOut={() => {
          this.setState({
            rateHover: 0
          });
        }}
      >
        <span className={classnames({
          'd-none': rateDisplay >= i
        })}><i className={classnames({
          'fas fa-star': true,
          'fa-2x': !isMobile
        })} style={{
          color: '#91908c',
          fontSize: '22px',
        }} /></span>

        <span className={classnames({
          'd-none': rateDisplay < i
        })}><i className={classnames({
          'fas fa-star': true,
          'fa-2x': !isMobile
        })} style={{
          color: '#ffee00',
          fontSize: '22px',
        }}/></span>
      </div>);
    }

    return (
      <Row style={{
        minHeight: '205px'
      }}>
        <Col className="text-center">
          <p style={{
            fontSize: '2em'
          }}>Oceń ankietę!</p>
          <div className="mx-auto d-flex flex-nowrap align-items-center justify-content-between" style={{maxWidth: 500}}>
            {rateButtons}
          </div>

          {rateDisplay > 0 && <span className="d-block w-100 text-center mb-3" style={{
            color: rateTexts[rateDisplay].color,
            fontSize: '1.5em',
          }}>{rateTexts[rateDisplay].text}</span>}

          {rate > 0 && <LaddaButton
            className="btn btn-primary btn-ladda mb-0 w-100 py-2 rate-button"
            loading={saving}
            data-style={ZOOM_OUT}
            onClick={this.onClickSave}
          >
            Zapisz ocenę
          </LaddaButton>}
        </Col>
      </Row>
    );
  }
}

Rate.propTypes = {
  surveyResponse: PropTypes.shape({
    rate: PropTypes.shape({
      rate: PropTypes.string,
    }),
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse,
  }
}

export default connect(mapStateToProps)(Rate);
